import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LMToolbarComponent } from '@toolbar/lm-toolbar.component';
import { LMFormatUtilService } from '@services/utils';
import { SohoDataGridComponent } from 'ids-enterprise-ng';

@Component({
  selector:    'lm-list-audit-compare-panel',
  templateUrl: './lm-list-audit-compare-panel.component.html',
  styleUrls:   [ './lm-list-audit-compare-panel.component.css' ]
})
export class LMListAuditComparePanelComponent implements OnInit {

  @ViewChild(SohoDataGridComponent, { static: true }) dataGridComponent: SohoDataGridComponent;
  @ViewChild(LMToolbarComponent) toolBarComponent: LMToolbarComponent;

  @Input() set changedValues(changedValues: Array<LMAuditCompareChangedValues>) {
    this._changedValues = changedValues;
    this.dataGridComponent.data = changedValues;
  }

  @Input() set emptyMessageTitle(emptyMessageTitle) {
    this._emptyMessageTitle = emptyMessageTitle;
    this.dataGridComponent.emptyMessage = { title: emptyMessageTitle };
  };

  @Input() title: string;


  private _changedValues: Array<LMAuditCompareChangedValues>;
  private _emptyMessageTitle: string;

  constructor(
    protected lmFormatUtilService: LMFormatUtilService
  ) {
    // no -op
  }

  ngOnInit() {
    this.build();
  }

  private build(): void {
    const headerColumns: SohoDataGridColumn[] = [
      {
        name:       Soho.Locale.translate('FieldName'),
        field:      'FieldName',
        sortable:   false,
        formatter:  'Ellipsis',
        singleline: true,
        minWidth: 100,
        width:    200,
        maxWidth: 200,
      },
      {
        name:       Soho.Locale.translate('OldValue'),
        field:      'FromValue',
        sortable:   false,
        formatter:  'Ellipsis',
        singleline: true,
        minWidth: 100,
        width:    200,
        maxWidth: 200,
      },
      {
        name:       Soho.Locale.translate('NewValue'),
        field:      'ToValue',
        sortable:   false,
        formatter:  'Ellipsis',
        singleline: true,
        minWidth: 100,
        width:    200,
        maxWidth: 200,
      }
    ];

    const changedValues = [];

    const gridOptions: SohoDataGridOptions = <SohoDataGridOptions> {
      columns:    headerColumns,
      dataset:    changedValues,
      selectable: false,
      paging:     false,
      rowReorder: true,
      rowHeight: 'short',
      enableTooltips: true
    };

    this.dataGridComponent.gridOptions = gridOptions;
  }
}
